export default "__VITE_ASSET__9165151f__"